<template>
  <v-container pa-0 fill-height fluid>
    <v-layout align-space-around justify-start fill-height column>
      <v-form ref="form" lazy-validation>
        <v-container pt-0 fluid grid-list-md>
          <v-layout align-space-around justify-end>
              <v-spacer></v-spacer>
              <v-btn round color="primary" @click="ativarSmartlock">
                {{pessoa.smartlock_posto ? 'Desativar' : 'Ativar'}} SmartLock
              </v-btn>
            </v-layout>
            <h3 class="headline font-weight-light orange--text mb-2">Atualizar Foto de Perfil</h3>
              <div class="font-weight-light title mb-2">
              </div>
              <v-layout align-space-around justify-center>
                <v-card pa-0 v-show="croppingImagem">
                  <v-card-text class="pa-0">
                    <v-layout align-space-around justify-space-around full-height style="height: 400px">
                      <vue-croppie
                        ref="croppieRef"
                        :enableExif="true"
                        :enforceBoundary="true"
                        :enableResize="false"
                        :enableOrientation="false"
                        :mouseWheelZoom="true"
                        :showZoomer="false"
                        :boundary="{ width: 400, height: 400 }"
                        :viewport="{ width: 200, height: 200, type : 'circle' }"
                        >
                      </vue-croppie>
                    </v-layout>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn flat @click="recortarImagem">
                      Recortar imagem
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-layout>
              <v-flex sm12>
                <v-layout align-center column>
                  <v-avatar>
                    <img v-if="user && user.image" v-bind:src="user.image">
                  </v-avatar>
                  <v-btn flat color="primary" @click="$refs.imagemInput.click()" v-if="smartLock">
                    Carregar Foto
                    <input
                      type="file"
                      style="display:none"
                      accept="image/*"
                      ref="imagemInput"
                      @input="carregarImagem"
                    >
                  </v-btn>
                  <v-tooltip bottom v-else>
                    <v-btn flat color="primary" disabled slot="activator">
                      Carregar Foto
                    </v-btn>
                    Função inativa através do SmartLock (clique no cadeado no canto superior direito)
                  </v-tooltip>
                </v-layout>
              </v-flex>
              <h3 class="headline font-weight-light orange--text mb-2">Dados Pessoais</h3>
              <div class="font-weight-light title mb-2">
              </div>
              <v-layout wrap>
                  <v-flex
                    xs12
                    sm6
                    md4
                  >
                  <v-text-field
                    label="Nome"
                    v-model="clienteEdicao.nome"
                    required
                    :readonly="!smartLock"
                  ></v-text-field>
                  </v-flex>
                <v-flex
                  xs12
                  sm6
                  md4
                >
                  <v-text-field
                    label="Sobrenome"
                    v-model="clienteEdicao.sobrenome"
                    :readonly="!smartLock"
                  ></v-text-field>
                </v-flex>
                <v-flex
                  xs12
                  sm6
                  md4
                >
                <v-text-field
                    label="CPF"
                    v-model="clienteEdicao.cpf"
                    :readonly="true"
                  ></v-text-field>
                </v-flex>
                <v-flex
                  xs12
                  sm6
                  md2
                >
                <v-text-field
                    label="Telefone"
                    v-model="clienteEdicao.telefone"
                    :readonly="true"
                  ></v-text-field>
                </v-flex>
                <v-flex
                  xs12
                  sm8
                  md4
                >
                <v-text-field
                    label="Email"
                    v-model="clienteEdicao.email"
                    :readonly="true"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <h3 class="headline font-weight-light orange--text mb-2">Endereço</h3>
              <div class="font-weight-light title mb-2">
              </div>
              <v-layout wrap>
                <v-flex xs12 sm6 md4>
                    <v-text-field
                      @keyup="searchCep"
                      label="CEP"
                      v-model="clienteEdicao.cep"
                      required
                      :readonly="!smartLock"
                    ></v-text-field>
                    </v-flex>
                      <v-flex
                      xs12
                      sm8
                    >
                      <v-text-field
                        label="Logradouro"
                        v-model="clienteEdicao.logradouro"
                        :readonly="!smartLock"
                      ></v-text-field>
                    </v-flex>
                    <v-flex
                      xs12
                      sm8
                      md4
                    >
                    <v-text-field
                        label="Bairro"
                        v-model="clienteEdicao.bairro"
                        :readonly="!smartLock"
                      ></v-text-field>
                    </v-flex>
                    <v-flex
                      xs12
                      sm8
                      md4
                    >
                    <v-text-field
                        label="Numero"
                        v-model="clienteEdicao.numero"
                        :readonly="!smartLock"
                      ></v-text-field>
                    </v-flex>
                    <v-flex
                      xs12
                      sm8
                    >
                    <v-text-field
                        label="Complemento"
                        v-model="clienteEdicao.complemento"
                        :readonly="!smartLock"
                      ></v-text-field>
                    </v-flex>
                    <v-flex
                      xs12
                      sm8
                      md4
                    >
                    <v-text-field
                        label="Cidade"
                        v-model="clienteEdicao.cidade"
                        :readonly="!smartLock"
                      ></v-text-field>
                    </v-flex>
                    <v-flex
                      xs12
                      sm8
                      md4
                    >
                    <v-text-field
                        label="Estado"
                        v-model="clienteEdicao.estado"
                        :readonly="!smartLock"
                      ></v-text-field>
                    </v-flex>
                    <v-flex
                      xs12
                      sm8
                      md4
                    >
                    <v-text-field
                        label="Pais"
                        v-model="clienteEdicao.pais"
                        :readonly="!smartLock"
                      ></v-text-field>
                  </v-flex>
                </v-layout>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  flat
                  color="primary"
                  @click="atualizarCliente"
                  v-if="smartLock"
                >
                  Salvar
                </v-btn>
                <v-tooltip v-else bottom>
                  <v-btn
                    flat
                    color="primary"
                    disabled
                    slot="activator"
                  >
                    Salvar
                  </v-btn>
                  Função inativa através do SmartLock (clique no cadeado no canto superior direito)
                </v-tooltip>
              </v-card-actions>
        </v-container>
        <v-dialog v-model="confirmacaoDados" width="500">
          <v-card>
            <v-card-title
              class="headline grey lighten-2"
              primary-title
            >
            Informações Atualizadas
            </v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" flat @click="confirmacaoDados=false">
                ok
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-form>
    </v-layout>
  </v-container>
</template>

<script>

window.EXIF = require('exif-js')

export default {
  data () {
    return {
      croppingImagem: false,
      menu1: false,
      date: new Date().toISOString().substr(0, 10),
      confirmacaoDados: false,
      hasSmartLock: false,
      clienteEdicao: {
        id_pessoa: '',
        nome: '',
        sobrenome: '',
        cpf: '',
        sexo: '',
        data_cadastro: '',
        telefone: '',
        email: '',
        cep: '',
        logradouro: '',
        bairro: '',
        numero: '',
        complemento: '',
        cidade: '',
        estado: '',
        pais: '',
        url_imagem_perfil: ''
      }
    }
  },
  computed: {
    user (val) {
      return this.$store.getters.user
    },
    headers () {
      return this.$store.getters.headers
    },
    pessoa () {
      return this.$store.getters.pessoa
    },
    ready () {
      return this.headers && this.cliente
    },
    fotoPerfil () {
      return this.$store.getters.fotoPerfil
    },
    smartLock () {
      const pessoa = this.$store.getters.pessoa
      if (pessoa) {
        return this.$store.getters.smartLock || !pessoa.smartlock_posto
      } else {
        return this.$store.getters.smartLock
      }
    }
  },
  watch: {
    pessoa (val) {
      if (val !== null && val !== undefined) {
        this.clienteEdicao = { ...val, ...val.endereco }
      }
    }
  },
  mounted () {
    if (this.pessoa) {
      this.clienteEdicao = { ...this.pessoa, ...this.pessoa.endereco }
    }
  },
  methods: {
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    parseDate (date) {
      if (!date) return null

      const [day, month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    searchCep () {
      fetch(`https://viacep.com.br/ws/${this.clienteEdicao.cep}/json/`, {
        method: 'get',
        mode: 'cors',
        headers: {
          Accept: 'application/json'
        }
      })
        .then(res => res.json())
        .then(json => {
          this.clienteEdicao.logradouro = json.logradouro
          this.clienteEdicao.bairro = json.bairro
          this.clienteEdicao.cidade = json.localidade
          this.clienteEdicao.estado = json.uf
        })
    },
    atualizarCliente () {
      var body = { ...this.clienteEdicao }
      this.$store.dispatch('atualizarPerfil', body).then(() => {
        this.confirmacaoDados = true
      })
    },
    recortarImagem () {
      let options = {
        type: 'base64',
        format: 'png',
        circle: true
      }
      this.$refs.croppieRef.result(options, (output) => {
        this.cropped = output
        this.croppingImagem = false
        this.$store.dispatch('atualizarFotoPerfil', { id: this.user.id, imagem: this.cropped })
      })
    },
    carregarImagem (event) {
      if (event.target.files && event.target.files[0]) {
        let imagem = event.target.files[0]
        let reader = new FileReader()
        reader.onloadend = (e) => {
          this.croppingImagem = true
          this.$refs.croppieRef.bind({
            url: reader.result
          })
          this.$nextTick(() => {
            this.$refs.croppieRef.setZoom(0.1)
          })
        }
        reader.readAsDataURL(imagem)
      }
    },
    ativarSmartlock () {
      this.$store.dispatch('ativarSmartlock')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
